/* tslint:disable */
/* eslint-disable */
/**
 * e-SNRWB
 * Opis api e-SNRWB
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReportProductsByType
 */
export interface ReportProductsByType {
    /**
     * 
     * @type {string}
     * @memberof ReportProductsByType
     */
    reportName: string;
    /**
     * 
     * @type {Array<object>}
     * @memberof ReportProductsByType
     */
    data: Array<object>;
}

export function ReportProductsByTypeFromJSON(json: any): ReportProductsByType {
    return ReportProductsByTypeFromJSONTyped(json, false);
}

export function ReportProductsByTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReportProductsByType {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'reportName': json['reportName'],
        'data': json['data'],
    };
}

export function ReportProductsByTypeToJSON(value?: ReportProductsByType | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'reportName': value.reportName,
        'data': value.data,
    };
}


